import { Primitive } from './Primitive';
import { Type } from './Type';
export class Float64Range extends Primitive {
    lowerBound;
    lowerInclusive;
    upperBound;
    upperInclusive;
    constructor(params) {
        super(Type.Float64Range);
        this.lowerBound = params.lowerBound;
        this.lowerInclusive = params.lowerInclusive;
        this.upperBound = params.upperBound;
        this.upperInclusive = params.upperInclusive;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmxvYXQ2NFJhbmdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9GbG9hdDY0UmFuZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGFBQWEsQ0FBQTtBQUN2QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFBO0FBUzdCLE1BQU0sT0FBTyxZQUFhLFNBQVEsU0FBUztJQUNoQyxVQUFVLENBQVE7SUFDbEIsY0FBYyxDQUFTO0lBQ3ZCLFVBQVUsQ0FBUTtJQUNsQixjQUFjLENBQVM7SUFFaEMsWUFBWSxNQUEwQjtRQUNwQyxLQUFLLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFBO1FBQ3hCLElBQUksQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQTtRQUNuQyxJQUFJLENBQUMsY0FBYyxHQUFHLE1BQU0sQ0FBQyxjQUFjLENBQUE7UUFDM0MsSUFBSSxDQUFDLFVBQVUsR0FBRyxNQUFNLENBQUMsVUFBVSxDQUFBO1FBQ25DLElBQUksQ0FBQyxjQUFjLEdBQUcsTUFBTSxDQUFDLGNBQWMsQ0FBQTtJQUM3QyxDQUFDO0NBQ0YifQ==